var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.74023 1.08203C3.86719 0.802734 4.14648 0.625 4.45117 0.625H7.52344C7.82812 0.625 8.10742 0.802734 8.23438 1.08203L8.4375 1.4375H10.875C11.3066 1.4375 11.6875 1.81836 11.6875 2.25C11.6875 2.70703 11.3066 3.0625 10.875 3.0625H1.125C0.667969 3.0625 0.3125 2.70703 0.3125 2.25C0.3125 1.81836 0.667969 1.4375 1.125 1.4375H3.5625L3.74023 1.08203ZM10.3164 12.4824C10.291 13.1426 9.75781 13.625 9.09766 13.625H2.87695C2.2168 13.625 1.68359 13.1426 1.6582 12.4824L1.09961 3.875H10.875L10.3164 12.4824Z",
    fill: "#555555"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.f7ac966d0bbc0932fb314fc37751cafe.svg";
export { ForwardRef as ReactComponent };